module.exports = __webpack_public_path__ + "static/assets/0136d7b1618e6d7ecaf97717bd128a05.jpg";